import { inCategory, type LibraryEntry } from '@echo/core';
import { useLibrary } from '@echo/core/react';
import { createFileRoute, useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router';
import { BrowsePage } from '@/components/browse-page';
import { LibraryRow } from '@/components/library-items';

export const Route = createFileRoute('/_app/library_/reading/$category')({
  component: ReadingBrowsePage,
});

/**
 * Library › Reading › a category (Figma library › browse), like Math's: the category's books
 * from the read-aloud library, how many there are, and each book's cover and tags (this
 * category and the reading time). Choosing a book opens its info.
 */
function ReadingBrowsePage() {
  const { category } = Route.useParams();
  const navigate = useNavigate();
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const library = useLibrary();
  const open = library.categories.find((candidate) => candidate.key === category);
  const rows = open ? inCategory(library.reading, open.key) : [];

  // A book opens its info first (Figma library › book info): read it or save it from there.
  const openBook = (entry: LibraryEntry) =>
    void navigate({
      to: '/library/book/$lineageUuid',
      params: { lineageUuid: entry.lineageUuid },
      search: { category },
    });

  return (
    <BrowsePage
      onBack={() => (canGoBack ? router.history.back() : navigate({ to: '/library' }))}
      ready={library.ready}
      failed={library.failed}
      onRetry={library.retry}
      title={open?.label}
      count={rows.length}
    >
      {rows.map((entry) => (
        <LibraryRow
          key={entry.lineageUuid}
          entry={entry}
          tags={library.tagsFor(entry, category)}
          onClick={() => openBook(entry)}
        />
      ))}
    </BrowsePage>
  );
}
